(function () {
  'use strict';
  var PX = 'nb';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  /* <nb-blueprint>: the hero counters count up once (final numbers stay when motion is reduced) */
  if (!customElements.get(PX + '-blueprint')) customElements.define(PX + '-blueprint', class extends HTMLElement {
    connectedCallback() {
      if (this._played) return;
      var nodes = [].slice.call(this.querySelectorAll('[data-count]'));
      if (!nodes.length || (reduce && reduce.matches)) return;
      this._played = true; this._raf = 0; this._timer = 0;
      var self = this;
      nodes.forEach(function (el) { el._final = el.textContent; el.textContent = el._final.replace(/\d+/g, '0'); });
      var t0 = 0, D = 1400, GAP = 140;
      function frame(now) {
        if (!t0) t0 = now; var busy = false;
        nodes.forEach(function (el, i) {
          var k = Math.max(0, Math.min(1, (now - t0 - i * GAP) / D));
          el.textContent = el._final.replace(/\d+/g, function (m) { return String(Math.round(Number(m) * ease(k))); });
          if (k < 1) busy = true;
        });
        self._raf = busy ? requestAnimationFrame(frame) : 0;
      }
      this._timer = setTimeout(function () { self._raf = requestAnimationFrame(frame); }, 350);
    }
    disconnectedCallback() {
      clearTimeout(this._timer); if (this._raf) cancelAnimationFrame(this._raf);
      if (this._played) { this.querySelectorAll('[data-count]').forEach(function (el) { if (el._final != null) el.textContent = el._final; }); this._played = false; }
    }
  });

  /* <nb-added>: on the cart page, says what was just added (the page before stored it) */
  if (!customElements.get(PX + '-added')) customElements.define(PX + '-added', class extends HTMLElement {
    connectedCallback() {
      var raw = null;
      try { raw = window.sessionStorage.getItem('nb-added'); window.sessionStorage.removeItem('nb-added'); } catch (e) { raw = null; }
      if (!raw) return;
      var d = null; try { d = JSON.parse(raw); } catch (e) { d = null; }
      if (!d || !d.t) return;
      var W = words(), self = this;
      var v = d.v && d.v !== 'Default Title' ? ' · ' + esc(d.v) : '';
      this.innerHTML = '<span class="' + PX + '-added__ic" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>' +
        '<span class="' + PX + '-added__msg"><strong>' + esc(W.added) + ':</strong> ' + esc(d.t) + v + (d.q > 1 ? ' × ' + d.q : '') + '</span>' +
        '<button type="button" class="' + PX + '-added__x" aria-label="' + esc(W.close) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" focusable="false" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
      this.hidden = false;
      var x = this.querySelector('button');
      if (x) x.addEventListener('click', function () { self.hidden = true; });
    }
  });

  function afterAdd(after) {
    var a = lastAdded && lastAdded.items && lastAdded.items[0];
    try { window.sessionStorage.setItem('nb-added', JSON.stringify({ t: a ? a.product_title : '', v: a ? a.variant_title : '', q: a ? a.quantity : 1 })); } catch (e) { /* private mode: no notice, still goes to the cart */ }
    window.location.href = cartUrl();
    return true;
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'nb';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
